import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import FlatButton from 'material-ui/FlatButton';
import { Step, Stepper, StepLabel } from 'material-ui/Stepper';
import TextField from 'material-ui/TextField';
import LinearProgress from 'material-ui/LinearProgress';
import ReactGA from 'react-ga';
import ResponsiveDialog from '../responsive_dialog/responsive_dialog';

import GA from '../../services/ga_events';

import './pair_device_dialog.scss';

export default class PairDeviceDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    pairing: PropTypes.bool.isRequired,
    pairDevice: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      pairCode: '',
      deviceName: '',
    };
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.props.onRequestClose}
      />,
      <FlatButton
        label="Pair"
        primary
        disabled={this.props.pairing || !this.state.pairCode || !this.state.deviceName}
        onClick={() => {
          const GAEvent = GA.pair;
          GAEvent.label = this.state.deviceName;
          ReactGA.event(GAEvent);
          return this.props.pairDevice(this.state.pairCode, this.state.deviceName)
            .then(() => { this.setState({ pairCode: '', deviceName: '' }); });
        }}
      />,
    ];

    const pairingStatus = (
      <div className="pair-device-pairing-status">
        <h4>Pairing, please wait</h4>
        <LinearProgress mode="indeterminate" />
      </div>
    );

    return (
      <ResponsiveDialog
        modal={false}
        open={this.props.open}
        onRequestClose={this.props.onRequestClose}
        actions={actions}
      >
        <div className="pair-device-dialog">
          <div className="pair-device-how-to">
            Pair your device in 3 simple steps
          </div>
          <MediaQuery maxDeviceWidth={900}>
            {small => (
              <Stepper
                activeStep={2}
                orientation={small ? 'vertical' : 'horizontal'}
              >
                <Step completed={false}>
                  <StepLabel className="pair-device-step-label">
                    Open the device browser
                  </StepLabel>
                </Step>
                <Step completed={false}>
                  <StepLabel className="pair-device-step-label">
                    Go to teamhub.tv/tv
                  </StepLabel>
                </Step>
                <Step>
                  <StepLabel className="pair-device-step-label">
                    Type here the code from the device screen and its name
                  </StepLabel>
                </Step>
              </Stepper>
            )}
          </MediaQuery>

          <TextField
            className="pair-device-input"
            hintText="Pair code"
            type="number"
            disabled={this.props.pairing}
            onChange={(_event, newValue) => {
              this.setState({ pairCode: newValue });
            }}
          />
          <br />
          <TextField
            className="pair-device-input"
            hintText="Device name"
            disabled={this.props.pairing}
            onChange={(_event, newValue) => {
              this.setState({ deviceName: newValue });
            }}
          />

          {
            this.props.pairing
              && pairingStatus
          }
        </div>
      </ResponsiveDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pair_device_dialog/pair_device_dialog.jsx